import { Box, Button } from "@mui/material";
import { ShareStatus } from "@zoom/videosdk";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { ScreenShareControlBar } from "../../../../styled/SelfShareView";
import { RoomContext } from "../context/roomContext";

const ShareBar = forwardRef((props, ref) => {
  const zmClient = useContext(RoomContext);
  const mediaStream = zmClient.getMediaStream();
  const [status, setStatus] = useState(
    mediaStream?.getShareStatus() ?? undefined,
  );

  const onShareStatusChange = useCallback(() => {
    if (status !== mediaStream?.getShareStatus()) {
      setStatus(mediaStream?.getShareStatus());
    }
  }, [status, mediaStream]);

  useEffect(() => {
    zmClient.on("user-updated", onShareStatusChange);
    return () => {
      zmClient.off("user-updated", onShareStatusChange);
    };
  }, [zmClient, onShareStatusChange]);

  return (
    <Box
      sx={{
        display: status === ShareStatus.End ? "none" : "block",
      }}>
      <ScreenShareControlBar>
        {mediaStream?.isStartShareScreenWithVideoElement() ? (
          <video
            id={"ZOOM_WEB_SDK_SHARER_CANVAS"}
            className="share-bar-canvas"
            ref={ref}
          />
        ) : (
          <canvas
            id={"ZOOM_WEB_SDK_SHARER_CANVAS"}
            className="share-bar-canvas"
            ref={ref}
          />
        )}
        <Button
          variant="contained"
          onClick={() => mediaStream.stopShareScreen()}
          sx={{
            marginLeft: 1,
            backgroundColor: "rgba(42, 93, 247, 0.75)",
          }}>
          Dejar de compartir
        </Button>
      </ScreenShareControlBar>
    </Box>
  );
});

export default ShareBar;
